module.exports = __webpack_public_path__ + "img/linkedin.ba818adb.svg";